import jsPDF from 'jspdf';


export const getPDFBase64_HTML = async (): Promise<any> => {
  try {
    const pdf = await generatePDF_HTML()
    const base64PDF = pdf.output("blob")
    return blobToBase64(base64PDF);
  } catch (e) {
    return e;
  }
}
export const generatePDF_HTML = async (): Promise<jsPDF> => {
  try {
    const pdf = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "a4",
    });

    const htmlContent = generatePdfFromHtml();
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return new Promise((resolve, reject) => {
      pdf.html(parsedHtml.body, {
        callback: (doc) => resolve(doc),
        x: 10,
        y: 10,
        html2canvas: {
          scale: 0.26,
          useCORS: true,
          ignoreElements: (element) => element.nodeName === "SCRIPT",
        },
      });
    });
  } catch (e) {
    console.error("Error generating PDF:", e);
    throw e;
  }
};
export const generatePdfFromHtml = () => {
  const documentContainer = Array.from(document.getElementsByClassName('jrPage'));

  if (documentContainer?.length === 0) throw new Error('PDF pages Not Found on HTML');

  const style = generateStyle();

  let pdfContent = `<!DOCTYPE html><html lang="pt"><head><meta charset="UTF-8"><title>Document</title></head><body>${style}`;

  for (const html of documentContainer) {
    pdfContent = `${pdfContent}${html.outerHTML}`;
  }

  return `${pdfContent}</body></html>`;
};
export const generateStyle = () => `
  <style type="text/css">
    body { color: #000 !important; }
    .jrPage, .jrPage td, .jrPage span { color: #000 !important; } 
    .jrPage {
    page-break-inside: avoid;
    }
  </style>`;

export function blobToBase64(blob: Blob): Promise<ArrayBuffer | string | null> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}